import { Box, Typography } from '@mui/material';

export const AIOOutcomeHeader = () => {
  return (
    <Box
      sx={{
        textAlign: 'center',
        mb: { xs: 3, md: 4 },
      }}
    >
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontFamily: 'DM Sans',
          fontWeight: 700,
          fontSize: { xs: 24, sm: 28, md: 32 },
          lineHeight: 1.2,
          color: 'black',
          mb: 1,
          paddingTop: '30px',
        }}
      >
        Call Outcome
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontFamily: 'DM Sans',
          fontWeight: 500,
          fontSize: 16,
          lineHeight: 1.4,
          color: 'black',
        }}
      >
        Select an outcome to continue
      </Typography>
    </Box>
  );
};
